export default __webpack_public_path__ + "static/media/pompownia_glowna.f71eab25.png";